import {
  IPartner,
  IPartnerData
} from './index'
import {
  Image
} from '../../abstract'

export class Partner extends Image implements IPartner {
  readonly link?: string;

  constructor(data?: IPartnerData) {
    super(data)
    this.link = data?.link
  }

  get key(): string {
    let id = this.id;
    return this.name + (id ? ('-' + id) : '');
  }
}
